require("../coord/radar/Radar");

require("../coord/radar/RadarModel");

require("./radar/RadarView");


//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/radar.js
// module id = 900
// module chunks = 1